import { ajax } from "../services/ajax";
import { api } from "../constants";
import queryString from "../utils/queryString";
import { enDigits } from "../utils/formatDigits";

export default ({
  type,
  text,
  page,
  size
}) => {
  const queries = { page, size };
  if (type === 'user') {
    if (Number(1 * enDigits(text))) {
      queries.mobileNumber = enDigits(text)
    } else {
      queries.email = text
    }
  } else {
    queries.text = text
  }
  return ajax.get(
    api.endpoints.search(type) + '?' + queryString(queries)
  )
}
